import React from "react";
import loadable from "@loadable/component";
import GlobalLoader from "../../../components/GlobalLoader";

const LodableComponent = loadable(() => import("./index"), {
  fallback: <GlobalLoader isLoading />,
});

export default LodableComponent;
